interface Account {
  account_id: string;
  name: string;
}

interface Props {
  accounts: Account[];
  value: string;
  onChange: (accountId: string) => void;
}

export function AccountPicker({ accounts, value, onChange }: Props) {
  const options = [{ account_id: 'all', name: 'Todas as contas' }, ...accounts];

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      {options.map(acc => {
        const isActive = value === acc.account_id;
        return (
          <button
            key={acc.account_id}
            onClick={() => onChange(acc.account_id)}
            style={{
              padding: '6px 14px',
              borderRadius: '8px',
              border: `1px solid ${isActive ? 'var(--accent-border)' : 'var(--border-subtle)'}`,
              cursor: 'pointer',
              fontSize: '12px',
              fontFamily: 'var(--font-mono)',
              fontWeight: 500,
              background: isActive ? 'var(--accent-muted)' : 'transparent',
              color: isActive ? 'var(--accent)' : 'var(--text-tertiary)',
              transition: 'all 0.15s ease',
              whiteSpace: 'nowrap',
            }}
          >
            {acc.name}
          </button>
        );
      })}
    </div>
  );
}
